<template>
    <div class="c-section -white || o-padding -big-top -huge-bottom" data-scroll-section>
        <div class="o-container">
            <div class="o-grid -col-4 -col-8@from-medium -gutters c-sticky_section">
                <div id="target" class="c-sticky_target"></div>
                <div class="o-grid_item u-gc-1/4@from-medium">
                    <div class="o-padding -medium-bottom -no-padding-bottom@from-medium c-sticky_element" data-scroll data-scroll-sticky data-scroll-target="#target" data-scroll-position="top">
                        <figure class="c-figure -lazy-load -no-bg || c-text-illu_figure -form || o-padding -medium-bottom -no-padding-bottom@from-medium">
                            <div class="c-figure_inner">
                                <img class="c-figure_image" :src="'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 ' + image.width + ' ' + image.height + '\'%3E%3C/svg%3E'" :data-src="image.url" alt="" :width="image.width" :height="image.height" data-scroll data-scroll-call="lazyLoad, Scroll">
                            </div>
                        </figure>
                    </div>
                </div>
                <div class="o-grid_item u-gc-5/9@from-medium">
                    <form v-if="submited != true" ref="form$" @submit="checkForm" class="c-form" novalidate="true" :class="{ 'is-form-invalid': formInvalid, 'is-loading': loading, 'is-submited': submited }">
                        <div class="c-form_title">
                            {{ _t("Partnerships inquiry") }}
                        </div>
                        <!-- Company Name -->
                        <div class="c-form_item">
                            <TextInput id="SingleLine-arialabel" name="Vendor_Name" required="true" :labelText="_t('Company Name')" />
                        </div>
                        <!-- Name -->
                        <div class="c-form_item">
                            <label for="FullName" class="c-form_label -required">{{ _t("Name") }}</label>
                            <div class="c-form_item_group -group-1/2">
                                <TextInput id="FirstName" name="First_Name" required="true" :labelText="_t('First name')" />
                            </div>
                            <div class="c-form_item_group -group-1/2">
                                <TextInput id="LastName" name="Last_Name" required="true" :labelText="_t('Last name')" />
                            </div>
                        </div>
                        <!-- Email -->
                        <div class="c-form_item">
                            <EmailInput id="Email" name="Email" required="true" :labelText="_t('Email')" />
                        </div>
                        <!-- Mobile -->
                        <div class="c-form_item">
                            <PhoneInput id="Mobile" name="Mobile" required="true" :labelText="_t('Mobile')" />
                        </div>
                        <!-- Phone -->
                        <div class="c-form_item">
                            <PhoneInput id="Phone" name="Phone" :labelText="_t('Phone')" />
                        </div>
                        <!-- Country -->
                        <div class="c-form_item">
                            <SelectInput id="Country" name="Country" required="true" :labelText="_t('Country')" :options="[
                                { value: 'Afghanistan', text: 'Afghanistan' },
                                { value: 'Albania', text: 'Albania' },
                                { value: 'Algeria', text: 'Algeria' },
                                { value: 'Andorra', text: 'Andorra' },
                                { value: 'Angola', text: 'Angola' },
                                { value: 'Antigua and Barbuda', text: 'Antigua and Barbuda' },
                                { value: 'Argentina', text: 'Argentina' },
                                { value: 'Armenia', text: 'Armenia' },
                                { value: 'Australia', text: 'Australia' },
                                { value: 'Austria', text: 'Austria' },
                                { value: 'Azerbaijan', text: 'Azerbaijan' },
                                { value: 'Bahamas', text: 'Bahamas' },
                                { value: 'Bahrain', text: 'Bahrain' },
                                { value: 'Bangladesh', text: 'Bangladesh' },
                                { value: 'Barbados', text: 'Barbados' },
                                { value: 'Belarus', text: 'Belarus' },
                                { value: 'Belgium', text: 'Belgium' },
                                { value: 'Belize', text: 'Belize' },
                                { value: 'Benin', text: 'Benin' },
                                { value: 'Bhutan', text: 'Bhutan' },
                                { value: 'Bolivia', text: 'Bolivia' },
                                { value: 'Bosnia and Herzegovina', text: 'Bosnia and Herzegovina' },
                                { value: 'Botswana', text: 'Botswana' },
                                { value: 'Brazil', text: 'Brazil' },
                                { value: 'Brunei', text: 'Brunei' },
                                { value: 'Bulgaria', text: 'Bulgaria' },
                                { value: 'Burkina Faso', text: 'Burkina Faso' },
                                { value: 'Burundi', text: 'Burundi' },
                                { value: 'Cabo Verde', text: 'Cabo Verde' },
                                { value: 'Cambodia', text: 'Cambodia' },
                                { value: 'Cameroon', text: 'Cameroon' },
                                { value: 'Canada', text: 'Canada' },
                                { value: 'Central African Republic', text: 'Central African Republic' },
                                { value: 'Chad', text: 'Chad' },
                                { value: 'Chile', text: 'Chile' },
                                { value: 'China', text: 'China' },
                                { value: 'Colombia', text: 'Colombia' },
                                { value: 'Comoros', text: 'Comoros' },
                                { value: 'Congo (Congo-Brazzaville)', text: 'Congo (Congo-Brazzaville)' },
                                { value: 'Costa Rica', text: 'Costa Rica' },
                                { value: 'Croatia', text: 'Croatia' },
                                { value: 'Cuba', text: 'Cuba' },
                                { value: 'Cyprus', text: 'Cyprus' },
                                { value: 'Czech Republic', text: 'Czech Republic' },
                                { value: 'Democratic Republic of the Congo', text: 'Democratic Republic of the Congo' },
                                { value: 'Denmark', text: 'Denmark' },
                                { value: 'Djibouti', text: 'Djibouti' },
                                { value: 'Dominica', text: 'Dominica' },
                                { value: 'Dominican Republic', text: 'Dominican Republic' },
                                { value: 'Ecuador', text: 'Ecuador' },
                                { value: 'Egypt', text: 'Egypt' },
                                { value: 'El Salvador', text: 'El Salvador' },
                                { value: 'Equatorial Guinea', text: 'Equatorial Guinea' },
                                { value: 'Eritrea', text: 'Eritrea' },
                                { value: 'Estonia', text: 'Estonia' },
                                { value: 'Eswatini', text: 'Eswatini' },
                                { value: 'Ethiopia', text: 'Ethiopia' },
                                { value: 'Fiji', text: 'Fiji' },
                                { value: 'Finland', text: 'Finland' },
                                { value: 'France', text: 'France' },
                                { value: 'Gabon', text: 'Gabon' },
                                { value: 'Gambia', text: 'Gambia' },
                                { value: 'Georgia', text: 'Georgia' },
                                { value: 'Germany', text: 'Germany' },
                                { value: 'Ghana', text: 'Ghana' },
                                { value: 'Greece', text: 'Greece' },
                                { value: 'Grenada', text: 'Grenada' },
                                { value: 'Guatemala', text: 'Guatemala' },
                                { value: 'Guinea', text: 'Guinea' },
                                { value: 'Guinea-Bissau', text: 'Guinea-Bissau' },
                                { value: 'Guyana', text: 'Guyana' },
                                { value: 'Haiti', text: 'Haiti' },
                                { value: 'Honduras', text: 'Honduras' },
                                { value: 'Hungary', text: 'Hungary' },
                                { value: 'Iceland', text: 'Iceland' },
                                { value: 'India', text: 'India' },
                                { value: 'Indonesia', text: 'Indonesia' },
                                { value: 'Iran', text: 'Iran' },
                                { value: 'Iraq', text: 'Iraq' },
                                { value: 'Ireland', text: 'Ireland' },
                                { value: 'Israel', text: 'Israel' },
                                { value: 'Italy', text: 'Italy' },
                                { value: 'Jamaica', text: 'Jamaica' },
                                { value: 'Japan', text: 'Japan' },
                                { value: 'Jordan', text: 'Jordan' },
                                { value: 'Kazakhstan', text: 'Kazakhstan' },
                                { value: 'Kenya', text: 'Kenya' },
                                { value: 'Kiribati', text: 'Kiribati' },
                                { value: 'Kuwait', text: 'Kuwait' },
                                { value: 'Kyrgyzstan', text: 'Kyrgyzstan' },
                                { value: 'Laos', text: 'Laos' },
                                { value: 'Latvia', text: 'Latvia' },
                                { value: 'Lebanon', text: 'Lebanon' },
                                { value: 'Lesotho', text: 'Lesotho' },
                                { value: 'Liberia', text: 'Liberia' },
                                { value: 'Libya', text: 'Libya' },
                                { value: 'Liechtenstein', text: 'Liechtenstein' },
                                { value: 'Lithuania', text: 'Lithuania' },
                                { value: 'Luxembourg', text: 'Luxembourg' },
                                { value: 'Madagascar', text: 'Madagascar' },
                                { value: 'Malawi', text: 'Malawi' },
                                { value: 'Malaysia', text: 'Malaysia' },
                                { value: 'Maldives', text: 'Maldives' },
                                { value: 'Mali', text: 'Mali' },
                                { value: 'Malta', text: 'Malta' },
                                { value: 'Marshall Islands', text: 'Marshall Islands' },
                                { value: 'Mauritania', text: 'Mauritania' },
                                { value: 'Mauritius', text: 'Mauritius' },
                                { value: 'Mexico', text: 'Mexico' },
                                { value: 'Micronesia', text: 'Micronesia' },
                                { value: 'Moldova', text: 'Moldova' },
                                { value: 'Monaco', text: 'Monaco' },
                                { value: 'Mongolia', text: 'Mongolia' },
                                { value: 'Montenegro', text: 'Montenegro' },
                                { value: 'Morocco', text: 'Morocco' },
                                { value: 'Mozambique', text: 'Mozambique' },
                                { value: 'Myanmar (Burma)', text: 'Myanmar (Burma)' },
                                { value: 'Namibia', text: 'Namibia' },
                                { value: 'Nauru', text: 'Nauru' },
                                { value: 'Nepal', text: 'Nepal' },
                                { value: 'Netherlands', text: 'Netherlands' },
                                { value: 'New Zealand', text: 'New Zealand' },
                                { value: 'Nicaragua', text: 'Nicaragua' },
                                { value: 'Niger', text: 'Niger' },
                                { value: 'Nigeria', text: 'Nigeria' },
                                { value: 'North Korea', text: 'North Korea' },
                                { value: 'North Macedonia', text: 'North Macedonia' },
                                { value: 'Norway', text: 'Norway' },
                                { value: 'Oman', text: 'Oman' },
                                { value: 'Pakistan', text: 'Pakistan' },
                                { value: 'Palau', text: 'Palau' },
                                { value: 'Palestine', text: 'Palestine' },
                                { value: 'Panama', text: 'Panama' },
                                { value: 'Papua New Guinea', text: 'Papua New Guinea' },
                                { value: 'Paraguay', text: 'Paraguay' },
                                { value: 'Peru', text: 'Peru' },
                                { value: 'Philippines', text: 'Philippines' },
                                { value: 'Poland', text: 'Poland' },
                                { value: 'Portugal', text: 'Portugal' },
                                { value: 'Qatar', text: 'Qatar' },
                                { value: 'Romania', text: 'Romania' },
                                { value: 'Russia', text: 'Russia' },
                                { value: 'Rwanda', text: 'Rwanda' },
                                { value: 'Saint Kitts and Nevis', text: 'Saint Kitts and Nevis' },
                                { value: 'Saint Lucia', text: 'Saint Lucia' },
                                { value: 'Saint Vincent and the Grenadines', text: 'Saint Vincent and the Grenadines' },
                                { value: 'Samoa', text: 'Samoa' },
                                { value: 'San Marino', text: 'San Marino' },
                                { value: 'Sao Tome and Principe', text: 'Sao Tome and Principe' },
                                { value: 'Saudi Arabia', text: 'Saudi Arabia' },
                                { value: 'Senegal', text: 'Senegal' },
                                { value: 'Serbia', text: 'Serbia' },
                                { value: 'Seychelles', text: 'Seychelles' },
                                { value: 'Sierra Leone', text: 'Sierra Leone' },
                                { value: 'Singapore', text: 'Singapore' },
                                { value: 'Slovakia', text: 'Slovakia' },
                                { value: 'Slovenia', text: 'Slovenia' },
                                { value: 'Solomon Islands', text: 'Solomon Islands' },
                                { value: 'Somalia', text: 'Somalia' },
                                { value: 'South Africa', text: 'South Africa' },
                                { value: 'South Korea', text: 'South Korea' },
                                { value: 'South Sudan', text: 'South Sudan' },
                                { value: 'Spain', text: 'Spain' },
                                { value: 'Sri Lanka', text: 'Sri Lanka' },
                                { value: 'Sudan', text: 'Sudan' },
                                { value: 'Suriname', text: 'Suriname' },
                                { value: 'Sweden', text: 'Sweden' },
                                { value: 'Switzerland', text: 'Switzerland' },
                                { value: 'Syria', text: 'Syria' },
                                { value: 'Taiwan', text: 'Taiwan' },
                                { value: 'Tajikistan', text: 'Tajikistan' },
                                { value: 'Tanzania', text: 'Tanzania' },
                                { value: 'Thailand', text: 'Thailand' },
                                { value: 'Timor-Leste', text: 'Timor-Leste' },
                                { value: 'Togo', text: 'Togo' },
                                { value: 'Tonga', text: 'Tonga' },
                                { value: 'Trinidad and Tobago', text: 'Trinidad and Tobago' },
                                { value: 'Tunisia', text: 'Tunisia' },
                                { value: 'Turkey', text: 'Turkey' },
                                { value: 'Turkmenistan', text: 'Turkmenistan' },
                                { value: 'Tuvalu', text: 'Tuvalu' },
                                { value: 'Uganda', text: 'Uganda' },
                                { value: 'Ukraine', text: 'Ukraine' },
                                { value: 'United Arab Emirates', text: 'United Arab Emirates' },
                                { value: 'United Kingdom', text: 'United Kingdom' },
                                { value: 'United States', text: 'United States' },
                                { value: 'Uruguay', text: 'Uruguay' },
                                { value: 'Uzbekistan', text: 'Uzbekistan' },
                                { value: 'Vanuatu', text: 'Vanuatu' },
                                { value: 'Vatican City', text: 'Vatican City' },
                                { value: 'Venezuela', text: 'Venezuela' },
                                { value: 'Vietnam', text: 'Vietnam' },
                                { value: 'Yemen', text: 'Yemen' },
                                { value: 'Zambia', text: 'Zambia' },
                                { value: 'Zimbabwe', text: 'Zimbabwe' }
                            ]" />
                        </div>
                        <!-- Partner Type -->
                        <div class="c-form_item">
                            <SelectInput id="Dropdown2-arialabel" name="Vendor_Type" :labelText="_t('Partner Type')" :options="[
                                //{ value: 'External ISO', text: 'External ISO (VAR)' },
                                { value: 'External ISO1', text: 'External ISO' },
                                //{ value: 'Partner', text: 'Referral Partner (VAR)' },
                                { value: 'Referral Partner', text: 'Referral Partner' },
                                { value: 'Value Added Provider', text: 'Value Added Solution' },
                                { value: 'Advisor', text: 'Advisor (ISA)' },
                                { value: 'Service Provider', text: 'Service Provider' },
                                { value: 'other', text: 'Other - Specify in the notes section' }, 
                                //{ value: 'Internal ISO', text: 'Internal ISO' }
                            ]" />
                        </div>
                        <!-- Textarea -->
                         <div class="c-form_item">
                            <TextareaInput id="MultiLine-arialabel" name="Description" :labelText="_t('Tell us about your organization, and what you like to achieve with PandaPay')" />
                         </div>

                         <div class="c-form_controls">
                            <div class="c-form_button_group">
                                <button class="c-form_button_submit" type="submit">
                                    <span class="c-form_button_spinner"></span>
                                    {{ _t("Submit") }}
                                </button>
                            </div>
                        </div>
                        <input type="hidden" name="Partnership_status" value="Prospect">
                        <input type="hidden" name="Partner_Source" value="Website">
                    </form>

                    <div v-if="submited==true" class="c-form_success">
                        <div class="c-form_title">
                            {{ _t("Thank you") }}
                        </div>
                        <div class="c-form_success_title">
                            {{ _t("Your information has been submitted") }}
                        </div>
                        <div class="c-form_success_text">
                            {{ _t("We will be in touch shortly") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Image from './partials/Image.vue';
import RadioInput from './inputs/radio.vue';
import CheckboxInput from './inputs/checkbox.vue';
import TextInput from './inputs/text.vue';
import EmailInput from './inputs/email.vue';
import PhoneInput from './inputs/phone.vue';
import SelectInput from './inputs/select.vue';
import TextareaInput from './inputs/textarea.vue';

const randomImage = ASSETS.randomImage;
    export default {
        name: 'SalesWebsiteComponents',
        data() {
            return {
                loading: false,
                formInvalid: false,
                submited: false,
                image: randomImage
            }
        },
        components: {
            Image,
            RadioInput,
            CheckboxInput,
            TextInput,
            EmailInput,
            PhoneInput,
            SelectInput,
            TextareaInput
        },
        mounted() {
            //console.log('Sales Website Component mounted.')
        },
        methods: {
            checkForm(e) {
                e.preventDefault();
                this.loading = true;
                this.formInvalid = false;
                //Validate form manually
                let form = e.target;
                let isValid = form.checkValidity();
                if (!isValid) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.formInvalid = true;
                    this.loading = false;
                } else {
                    this.submitForm(e);
                }
            },
            async submitForm(e) {
                //Submit form data
                let formData = new FormData(e.target);
                let data = {
                    'form': {},
                    'module': 'Vendors'
                };
                formData.forEach((value, key) => {
                    data.form[key] = value;
                });
                //Use data json from e
                let response = await fetch('/wp-json/pandapay/v1/submit_custom_form', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                });
                //response = await response.json();

                if(response.ok == true) {
                    this.submited = true;
                    e.target.reset();

                    this.modu.call('scrollTo', { target: '#target', offset: -100 }, 'Scroll');
                } else {
                    this.submited = false;
                    this.loading = false;
                }
            }
        },
        watch: {
           //Watch form$ validity to change formInvalid
            '$refs.form$.validity'(validity) {
                this.formInvalid = !validity.valid;
            }
        }
    }
</script>